module.exports = __webpack_public_path__ + "img/11_54.f66f219f.png";